<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, validate }" tag="div">
    <b-form
      :id="'form-' + uid"
      :action="formAction"
      :method="content.typeRequete"
      @input="validate({ silent: true })"
    >
      <!-- Le b-link est nécessaire pour récupérer l'url pout l'input retURL. jel_getLienBinding est
        monté pour gérer la création de l'url par v-bind et est non compatible pour utilisation simple
        directement dans l'input retURL -->
      <b-link id="urlRetour" v-bind="jel_getLienBinding(content.lien)" class="d-none" />
      <input type="hidden" name="orgid" :value="inputValueOrgId" />
      <input type="hidden" name="retURL" :value="urlRetour()" />
      <input type="hidden" :name="inputValueLangueContact" :value="$i18n.locale === 'en' ? 0 : 1" />

      <RadioComboFiltre :content="contentRadioComboFiltre" class="mb-2" />
      <AireTexte :content="contentAireTexte" />

      <Titre
        :content="{
          titre: content.libTitreBlocInfo,
          type: 'titre',
          classeCSS: 'pt-1 mb-2',
        }"
      />

      <PrenomNom :content="contentPrenomNom" />
      <Courriel :content="contentCourriel" />
      <input
        :id="'sumbit-' + uid"
        type="submit"
        name="submit"
        :value="content.libBoutonEnvoyer"
        class="btn btn-primaire hauteur d-flex px-4 mx-auto mx-md-0"
        :disabled="invalid"
      />
    </b-form>
  </ValidationObserver>
</template>

<script>
import { load } from 'recaptcha-v3';

import AireTexte from '@/components/base/AireTexte';
import Courriel from '@/components/formulaire/compte/Courriel';
import PrenomNom from '@/components/formulaire/compte/PrenomNom';
import RadioComboFiltre from '@/components/formulaire/base/RadioComboFiltre.vue';
import Titre from '@/components/base/Titre';

export default {
  name: 'FormulaireBilletterieSalesforce',
  components: { AireTexte, Courriel, PrenomNom, RadioComboFiltre, Titre },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      recaptchaValidated: false,
      recaptchaPromise: null,
    };
  },
  computed: {
    formAction() {
      return process.env.VUE_APP_SALESFORCE_FROM_ACTION;
    },
    inputValueLangueContact() {
      return process.env.VUE_APP_SALESFORCE_FORMULAIRE_LANGUE_CONTACT;
    },
    inputValueOrgId() {
      return process.env.VUE_APP_SALESFORCE_ORG_ID;
    },
    contentPrenomNom() {
      return {
        inputNameNom: process.env.VUE_APP_SALESFORCE_FORMULAIRE_NOM,
        inputNamePrenom: process.env.VUE_APP_SALESFORCE_FORMULAIRE_PRENOM,
        libPrenom: this.content.libPrenom,
        libNom: this.content.libNom,
      };
    },
    contentCourriel() {
      return {
        inputName: 'email',
        libCourriel: this.content.libCourriel,
      };
    },
    contentRadioComboFiltre() {
      const filtreListeOptions = {};
      let i = 0;
      this.content.optionsGroupeRadio['@nodes'].forEach((item) => {
        // changer la valeur à mettre dans le name de l'input pour envoyer les données à la bonne variable à Salesforce
        filtreListeOptions[`optionsGroupeRadio${i}`] = {
          ...this.content.optionsGroupeRadio[item],
          name: process.env.VUE_APP_SALESFORCE_FORMULAIRE_MOTIF,
        };
        i++;
      });
      return {
        ...this.content,
        optionsGroupeRadio: filtreListeOptions,
        inputNameChoix: process.env.VUE_APP_SALESFORCE_FORMULAIRE_SOUS_MOTIF,
      };
    },
    contentAireTexte() {
      return {
        ...this.content,
        inputNameAireTexte: 'description',
        reglesChoix: 'required',
      };
    },
  },
  mounted() {
    if (this.jel_isRecaptchaActive()) {
      this.recaptchaPromise = load(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
        autoHideBadge: true,
      });
    }
    document.getElementById(`form-${this.uid}`).addEventListener('submit', this.formSubmit);
  },
  methods: {
    // Récupères l'url du b-link url retour pour permettre au formulaire d'avoir le bon url de redirection
    urlRetour() {
      return document.getElementById('urlRetour')?.href;
    },
    async formSubmit(event) {
      const submitBtn = document.getElementById(`sumbit-${this.uid}`);
      submitBtn.disabled = true;
      if (!this.recaptchaValidated && this.jel_isRecaptchaActive()) {
        event.preventDefault();
        const self = this;
        this.recaptchaPromise.then((recaptcha) => {
          recaptcha.execute('registration').then(() => {
            // Forcer le click puisque event.preventDefault empêche le POST du formulaire vers Salesforce
            self.recaptchaValidated = true;
            submitBtn.disabled = false;
            document.getElementById(`sumbit-${self.uid}`).click();
          });
        });
      }
    },
  },
};
</script>
